import type { GitRefResource, ProjectResource, Repository, ValidateGitRefV2Response } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import type { ChannelLookupData } from "~/areas/projects/components/Channels/CreateOrEditChannelPageContent";
import { channelLookupDataLoader, CreateOrEditChannelPageContent } from "~/areas/projects/components/Channels/CreateOrEditChannelPageContent";
import { type ProjectContextProps } from "~/areas/projects/context/index";
export async function createChannelPageLoader(repository: Repository, projectContext: Promise<ProjectContextProps>, ephemeralEnvironmentsAreEnabled: boolean): Promise<CreateChannelPageLoaderData> {
    const lookupData = channelLookupDataLoader(repository, projectContext, ephemeralEnvironmentsAreEnabled);
    return {
        lookupData: await lookupData,
    };
}
interface CreateChannelPageLoaderData {
    lookupData: ChannelLookupData;
}
interface CreateChannelPageProps {
    loaderData: CreateChannelPageLoaderData;
    project: ProjectResource;
    gitRefValidationError: ValidateGitRefV2Response | undefined;
    gitRef: Readonly<GitRefResource> | undefined;
}
export function CreateChannelPage({ loaderData, project, gitRef, gitRefValidationError }: CreateChannelPageProps) {
    return (<CreateOrEditChannelPageContent channel="create new channel" lookupData={loaderData.lookupData} pageTitle={createChannelPageTitle} project={project} gitRef={gitRef} gitRefValidationError={gitRefValidationError} overflowMenuItems={{
            dialogs: [],
            menuItems: [],
        }}/>);
}
export const createChannelPageTitle = "Create Channel";
